export const manageGroupRoute = ({ groupId }) =>
  `/management_panel/groups_management/${groupId}`
